import { render, staticRenderFns } from "./NumberField.vue?vue&type=template&id=1981fee4&scoped=true"
import script from "./NumberField.vue?vue&type=script&lang=js"
export * from "./NumberField.vue?vue&type=script&lang=js"
import style0 from "./NumberField.vue?vue&type=style&index=0&id=1981fee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1981fee4",
  null
  
)

export default component.exports